import { render, staticRenderFns } from "./alert-error.vue?vue&type=template&id=1ebefba6&scoped=true"
import script from "./alert-error.vue?vue&type=script&lang=js"
export * from "./alert-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebefba6",
  null
  
)

export default component.exports